export enum CalendarListMode {
    Calendar = "calendar",
    List = "list",
}
